import { Tooltip, OverlayTrigger } from 'react-bootstrap'

function SoftClose({ auction }) {
    const tooltip = (
        <Tooltip id="soft-close-tooltip">
            A bid placed within the last three minutes of the auction adds three minutes to the remaining time.
        </Tooltip>
    );

    return auction?.soft_close ? (
        <div id="auction-detail-soft-close" className="soft-close">
            <OverlayTrigger placement="top" overlay={tooltip}>
            <span>
                Soft Close Activated
                <i className="fa fa-question-circle marginL5" aria-hidden="true"/>
            </span>
            </OverlayTrigger>
        </div>
    ) : null
}

export default SoftClose
